import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import ChatBoxService from '../core/service'

export const getListTopic = createAsyncThunk(
  'chatBox/getListTopic',
  async (params, { rejectWithValue }) => {
    try {
      const res = await ChatBoxService.getListTopic(params)
      if (res.success) {
        return res.data
      }
      return rejectWithValue({ loading: false })
    } catch (err) {
      if (axios.isCancel(err)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getListTopicScroll = createAsyncThunk(
  'chatBox/getListTopicScroll',
  async (params, { rejectWithValue }) => {
    try {
      const res = await ChatBoxService.getListTopic(params)
      if (res.success) {
        return res.data
      }
      return rejectWithValue({ loading: false })
    } catch (err) {
      if (axios.isCancel(err)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getMessageInTopic = createAsyncThunk(
  'chatBox/getMessageInTopic',
  async (params, { rejectWithValue }) => {
    try {
      const res = await ChatBoxService.getMessageInTopic(params)
      if (res.success) {
        return res.data
      }
      return rejectWithValue({ loading: false })
    } catch (err) {
      if (axios.isCancel(err)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const updateTopic = createAsyncThunk(
  'chatBox/updateTopic',
  async (params, { rejectWithValue }) => {
    try {
      const res = await ChatBoxService.updateTopic(params)
      if (res.success) {
        return {
          topicId: params?.TopicId,
          topicTitle: params?.TopicTitle,
          status: params?.Status,
        }
      }
      return rejectWithValue({ loading: false })
    } catch (err) {
      if (axios.isCancel(err)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getQuestion = createAsyncThunk(
  'chatBox/getQuestion',
  async (params, { rejectWithValue }) => {
    try {
      const res = await ChatBoxService.getQuestion(params)
      if (res.success) {
        return res.data
      }
      return rejectWithValue({ loading: false })
    } catch (err) {
      if (axios.isCancel(err)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getTopicMaxUpdatedDate = createAsyncThunk(
  'chatBox/getTopicMaxUpdatedDate',
  async (params, { rejectWithValue }) => {
    try {
      const res = await ChatBoxService.getTopicMaxUpdatedDate(params)
      if (res.success) {
        return res.data
      }
      return rejectWithValue({ loading: false })
    } catch (err) {
      if (axios.isCancel(err)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)
